import { matchPath } from 'react-router-dom';

/**
 * Returns the matched path between full path and path to match
 * @param {string} fullPath - full path of route
 * @param {string} pathToMatch - path to compare against the full path
 * @param {object} config - configs to go into react-router-dom matchPath fn
 */
export const getMatchPath = (fullPath: string, pathToMatch: string, config?: { [x: string]: string }) => {
  return matchPath<{ [x: string]: string }>(fullPath, {
    path: pathToMatch,
    exact: true,
    strict: false,
    ...config
  });
};
